import {connect} from 'react-redux';
import {Field, FieldArray, reduxForm, formValueSelector} from 'redux-form';
import {ActionsRow, ff, field, form, Icon} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import TablePanel from "../components/TablePanel";
import ListBox from "../components/ListBox";
import {changePosition, fixOrder} from "../utils/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsAltV} from "@fortawesome/free-solid-svg-icons";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

// Trik jelikož <option> neumí mít boolean hodnoty, které potřebujeme do VO
const NULL = "null";
const TRUE = "true";
const FALSE = "false";

/**
 * Formulář pro tvorbu/úpravu atributů souborů a jejich hodnot.
 */
class SouborAtributForm extends Component<WithTranslation> {

    static formName = 'SouborAtributForm';

    updateHodnoty = (hodnoty) => {
        this.props.change('hodnoty', hodnoty);
    };

    handleRemoveHodnota = (index) => {
        const newHodnoty = [...this.props.hodnoty];
        newHodnoty.splice(index, 1);
        fixOrder(newHodnoty, "poradi", index);
        this.updateHodnoty(newHodnoty);
    };

    handleHodnotaOrderChanged = (index1, index2) => {
        const newHodnoty = [...this.props.hodnoty];
        changePosition(newHodnoty, index1, index2);
        fixOrder(newHodnoty, "poradi", Math.min(index1, index2));
        this.updateHodnoty(newHodnoty);
    };

    renderIntField = ({input, placeholder}) => (
        <field.Number int {...input} placeholder={placeholder} />
    );

    renderStringField = ({input, placeholder}) => (
        <field.String {...input} placeholder={placeholder} />
    );

    renderSelectField = ({input, placeholder}) => (
        <field.Select {...input}>
            <option value={NULL} disabled>{placeholder}</option>
            <option value={TRUE}>Aktivní</option>
            <option value={FALSE}>Neaktivní</option>
        </field.Select>
    );

    renderHodnoty = ({fields}) => {
        const {t} = this.props;
        return <Card>
            <CardHeader>
                <ActionsRow actions={
                    <ButtonToolbar>
                        <Button type="button" onClick={() => fields.push({poradi: fields.length + 1})}>{t('new_f')}</Button>
                    </ButtonToolbar>
                }>
                    {t('values')}
                </ActionsRow>
            </CardHeader>
            <CardBody>
                {fields.length > 0 ?
                <TablePanel bordered>
                    <ListBox
                        items={fields.getAll() || []}
                        sortable
                        onChangeOrder={this.handleHodnotaOrderChanged}
                        renderItemContent={i => <CardBody key={i.index}>
                            <ActionsRow actions={
                                <Button onClick={this.handleRemoveHodnota.bind(this, i.index)} color="action action-hover">
                                    <Icon icon="trash-o"/>
                                </Button>
                            }>
                                <Row>
                                    {/*<Col xs={2}>*/}
                                        {/*<Field*/}
                                            {/*name={`hodnoty[${i.index}].poradi`}*/}
                                            {/*component={this.renderIntField}*/}
                                            {/*placeholder={"#"}*/}
                                        {/*/>*/}
                                    {/*</Col>*/}
                                    <Col xs={1} className="icon-hover">
                                        <FontAwesomeIcon icon={faArrowsAltV} size="lg" />
                                    </Col>
                                    <Col xs={7}>
                                        <Field
                                            name={`hodnoty[${i.index}].hodnotaAtribut`}
                                            component={this.renderStringField}
                                            placeholder={t('value')}
                                        />
                                    </Col>
                                    <Col xs={3}>
                                        <Field
                                            name={`hodnoty[${i.index}].neaktivni`}
                                            component={this.renderSelectField}
                                            placeholder={t('active')}
                                            format={value => value === true ? FALSE : value === false ? TRUE : NULL}
                                            normalize={value => value === NULL ? null : value !== TRUE}
                                        />
                                    </Col>
                                </Row>
                            </ActionsRow>
                        </CardBody>}
                    />
                </TablePanel> : <i>{t('no_values')}</i>}
            </CardBody>
        </Card>
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <Row>
                    <Col xs={4}>
                        <Card>
                            <CardHeader>
                                {t('admin.file_attribute')}
                            </CardHeader>
                            <CardBody>
                                <ff.String label={t('labels.name')} name="nazevAtribut" required disabled={submitting}/>
                                <CustomCheckboxField label={t('labels.required')} name="povinne" disabled={submitting}/>
                                <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting}/>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs={8}>
                        <FieldArray name="hodnoty" component={this.renderHodnoty} />
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(SouborAtributForm.formName);

const mapStateToProps = state => ({
    hodnoty: selector(state, "hodnoty"),
});

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: SouborAtributForm.formName,
})(SouborAtributForm)));

